export default __webpack_public_path__ + "static/media/current_state.f3ad9a0a.svg";